// extracted by mini-css-extract-plugin
export default {"wrapper":"V5-z"};